/*eslint-disable*/
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

// components
import GroupForm from '../../components/groupForm'
import PageHeader from '../../components/pageHeader'
import ConfirmationDialog from '../../components/confirmationDialog'

// constants
import {
  GROUP_INITIAL_STATE,
  CREATE_FORM_FIELDS_CONFIG,
} from './createGroup.constants'

// hooks
import useDialogVisibility from '../../hooks/useDialogVisibility'

// helpers
import { makeCreateGroupDTO, areFormValuesChanged } from './createGroup.helpers'
import { removeEmptyProperties } from '../../helpers/general'

//services
import { createGroup } from '../../services/groups'
import { generateUniqueId } from '../../utils/general'
import { validateGroup } from '../../components/groupForm/helpers/groupForm.validators'

//styles
import styles from './createGroup.module.scss'

function CreateGroup() {
  const navigate = useNavigate()
  const [group, setGroup] = useState(GROUP_INITIAL_STATE)
  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSuccessful, setIsSuccessful] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [alertBlurb, setAlertBlurb] = useState('')
  const [applicationFieldKey, setApplicationFieldKey] = useState(
    generateUniqueId()
  )
  const [
    isCancelConfirmationDialogOpen,
    openCancelConfirmationDialog,
    closeCancelConfirmationDialog,
  ] = useDialogVisibility(false)

  const handleCreateGroupSuccess = () => {
    const submittedGroupName = group.groupName
    setGroup(GROUP_INITIAL_STATE)
    setApplicationFieldKey(generateUniqueId())
    setErrors({})
    setIsSuccessful(true)
    setAlertBlurb(
      'A new user group (' + submittedGroupName + ') was created successfully.'
    )
    setShowAlert(true)
  }

  const handleCreateGroupFailure = (error) => {
    setIsSuccessful(false)
    setAlertBlurb(error?.message)
    setShowAlert(true)
  }

  const setAsSubmitted = () => setIsSubmitting(false)

  const onSubmit = () => {
    const errorMsgs = validateGroup(group)
    if (Object.keys(removeEmptyProperties(errorMsgs)).length >= 1) {
      setErrors(errorMsgs)
      return
    }
    setIsSubmitting(true)
    const groupDTO = makeCreateGroupDTO(group)
    createGroup(groupDTO)
      .then(handleCreateGroupSuccess)
      .catch(handleCreateGroupFailure)
      .finally(setAsSubmitted)
  }

  const onCancel = () => {
    if (areFormValuesChanged(group)) {
      openCancelConfirmationDialog()
    }
  }

  const handleSubmitCancelConfirmationDialog = () => {
    setErrors({})
    setGroup(GROUP_INITIAL_STATE)
    setApplicationFieldKey(generateUniqueId())
    closeCancelConfirmationDialog()
    window.scrollTo({ top: 0 })
    navigate('/')
  }

  const areGroupValuesChanged = areFormValuesChanged(group)
  return (
    <>
      <PageHeader />
      <GroupForm
        group={group}
        setGroup={setGroup}
        errors={errors}
        setErrors={setErrors}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
        formFieldsConfig={CREATE_FORM_FIELDS_CONFIG}
        applicationFieldKey={applicationFieldKey}
        areFormValuesChanged={areGroupValuesChanged}
        isSuccessful={isSuccessful}
        showAlert={showAlert}
        setShowAlert={setShowAlert}
        alertBlurb={alertBlurb}
      />
      <ConfirmationDialog
        showDialog={isCancelConfirmationDialogOpen}
        onSubmit={handleSubmitCancelConfirmationDialog}
        onCancel={closeCancelConfirmationDialog}
      />
    </>
  )
}

export default CreateGroup
